export const milestoneHeaderSectionStyles = {
    congratulationText: {
        marginLeft: '8px',
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#4CAF50',
        animation: 'slideIn 0.5s ease-out',
        display: 'inline-flex',
        alignItems: 'center',
        '@keyframes slideIn': {
            '0%': {
                opacity: 0,
                transform: 'translateX(-20px)'
            },
            '100%': {
                opacity: 1,
                transform: 'translateX(0)'
            }
        }
    },
    celebrationIcon: {
        fontSize: '16px',
        marginLeft: '2px',
        marginRight: '2px',
        color: '#4CAF50',
        display: 'inline-block',
        verticalAlign: 'middle'
    },
    progressCircle: {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#4CAF50', // Green color
        marginLeft: '8px',
        marginRight: '4px',
        boxShadow: '0 0 4px rgba(76, 175, 80, 0.3)',
        animation: 'pulse 2s infinite',
        '@keyframes pulse': {
            '0%': {
                boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.7)'
            },
            '70%': {
                boxShadow: '0 0 0 6px rgba(76, 175, 80, 0)'
            },
            '100%': {
                boxShadow: '0 0 0 0 rgba(76, 175, 80, 0)'
            }
        }
    }
}; 